import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

/**
 * "title": "Curus is succesvol opgeslagen",
 * "link": "/foo",
 * "type": "error",
 * "icon": "fa fa-exclamation-triangle"
 *         "fa fa-info-circle"
 */

export default class GlobalMessage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: true
        };

        this.removeMessage = this.removeMessage.bind(this);
        this.timer = "";
    }

    removeMessage(e) {
        if (e !== undefined) {
            e.preventDefault();
            e.stopPropagation();
        }

        clearTimeout(this.timer);
        this.setState({
            visible: false
        });
    }

    componentDidMount() {
        this.timer = setTimeout(() => {
            this.removeMessage(undefined);
        }, 10000);
    }

    render() {
        let classnames = classNames("global-message-item", this.props.type, { hidden: this.state.visible === false }, { clickable: this.props.link !== "" });

        if (this.props.link === "") {
            return (
                <div className={classnames}>
                    <i className={`global-message-icon ${this.props.icon}`} />
                    {this.props.title}
                    <div className="global-message-close" onClick={(e) => this.removeMessage(e)}>
                        <i className="fa fa-times" />
                    </div>
                </div>
            );
        } else {
            return (
                <a className={classnames} href={this.props.link}>
                    <i className={`global-message-icon ${this.props.icon}`} />
                    {this.props.title}
                    <div className="global-message-close" onClick={(e) => this.removeMessage(e)}>
                        <i className="fa fa-times" />
                    </div>
                </a>
            );
        }
    }
}

GlobalMessage.defaultProps = {
    type: "success", // success, warning, error
    icon: "fa fa-info-circle",
    title: "Dit is de titel van dit bericht",
    link: ""
};

GlobalMessage.propTypes = {
    title: PropTypes.string.isRequired
};
